import { PostType } from '../../../graphql/gen/types';

export enum ItemTypeSelectionEnum {
  All = 1,
  Post,
  Event,
  Milestone,
}

export interface ItemTypeSelection {
  value: ItemTypeSelectionEnum;
  displayName: string;
  types: PostType[];
}

export const getPlexRouteItemType = (
  itemTypeSelection: ItemTypeSelectionEnum
): 'posts' | 'events' | 'milestones' | undefined => {
  switch (itemTypeSelection) {
    case ItemTypeSelectionEnum.Post:
      return 'posts';
    case ItemTypeSelectionEnum.Event:
      return 'events';
    case ItemTypeSelectionEnum.Milestone:
      return 'milestones';
    case ItemTypeSelectionEnum.All:
      return undefined;
  }
};

export const getItemTypeSelection = (itemTypeSelection: ItemTypeSelectionEnum): ItemTypeSelection => {
  switch (itemTypeSelection) {
    case ItemTypeSelectionEnum.All: {
      return {
        value: itemTypeSelection,
        displayName: 'All',
        types: [PostType.Event, PostType.Post, PostType.Milestone],
      };
    }
    case ItemTypeSelectionEnum.Post: {
      return {
        value: itemTypeSelection,
        displayName: 'Posts',
        types: [PostType.Post],
      };
    }
    case ItemTypeSelectionEnum.Event: {
      return {
        value: itemTypeSelection,
        displayName: 'Events',
        types: [PostType.Event],
      };
    }
    case ItemTypeSelectionEnum.Milestone: {
      return {
        value: itemTypeSelection,
        displayName: 'Milestones',
        types: [PostType.Milestone],
      };
    }
  }
};
